import { call } from "../helpers/axiosInterceptor";

const getAllPoints = async () => {
  try {
    const { data } = await call.get("card/list",
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {
    
  }
};

const createPoints = async (payload: any) => {
  try {
    const { data } = await call.post(
      "card",
      { ...payload },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        },
      }
    );
    return data;
  } catch (e: any) {
    console.error("Error creating points:", e.response?.data || e.message);
    return { error: e.response?.data || "An error occurred" };
  }
};


const updatePoints = async (id: string, payload: any) => {
  try {
    const token = localStorage.getItem("refToken"); // ✅ Ensure this exists
    if (!token) {
      console.error("No token found in localStorage");
      return { error: "No token found" };
    }

    const { data } = await call.put(`card/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,  // ✅ Ensure proper format
      },
    });
    return data;
  } catch (e: any) {
    console.error("Error updating card:", e.response?.data || e.message);
    return { error: e.response?.data || "An error occurred" };
  }
};

const allocateCard = async (payload: any) => {
  try {
    const { data } = await call.post("userPoints", { ...payload },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {
    
  }
};

const deleteCard = async (id: string) => {
  try {
    const { data } = await call.delete(`card/${id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
    return data;
  } catch (e: any) {
    console.error("Error deleting card:", e.response?.data || e.message);
    return { error: e.response?.data || "An error occurred" };
  }
};

const getPointsByBatch = async (batchId: string) => {
  try {
    const { data } = await call.get(`userPoints/batch/${batchId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
    return data;
  } catch (e: any) {
    console.error("Error fetching batch points:", e.response?.data || e.message);
    return { error: e.response?.data || "An error occurred" };
  }
};


export { getAllPoints, createPoints, updatePoints, allocateCard, deleteCard, getPointsByBatch };

